import type { SensorDescriptor, SensorOptions } from '@dnd-kit/core';

/**
 * What a drag-and-drop view hands `DndContext` when the board does not allow
 * moving: no sensor, so nothing lifts.
 *
 * It replaces `useSensors(...(canMove ? [sensor] : []))`, which looks the same
 * and is not. `useSensors` memoises on its argument list, and React compares
 * dependency lists only up to the shorter one, so `[]` against `[sensor]` reads
 * as unchanged: whichever answer arrived first stuck. A board loaded straight
 * into a view rendered before its permissions did, and the sensors stayed off
 * for somebody allowed to drag; switching to a board where you are a viewer kept
 * them on, and every drop came back 403. So the sensor list is built once and
 * the choice is made here, with a stable empty array — `undefined` would mean
 * dnd-kit's default sensors.
 */
export const NO_SENSORS: SensorDescriptor<SensorOptions>[] = [];
